var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { get } from "./axios";
export function isFeaturedWorkout(workout) {
    var _a;
    return ((_a = workout) === null || _a === void 0 ? void 0 : _a.contentType) === "WORKOUT";
}
export function isFeaturedPlan(plan) {
    var _a;
    return ((_a = plan) === null || _a === void 0 ? void 0 : _a.contentType) === "PLAN";
}
export function isFeaturedAthlete(athlete) {
    var _a;
    return ((_a = athlete) === null || _a === void 0 ? void 0 : _a.contentType) === "ATHLETE";
}
export const getFeatured = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get("/v1/television/content", {
        includeFeatured: "true",
        countPerSection: 4,
    }, { cacheKey: "featured-plans" });
    const featured = response.featured;
    while (featured.length < 4) {
        featured.push(featured[0]);
    }
    return featured;
});
export const getPreviews = (range) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield get("/v1/television/content", {
        includeAthletes: "true",
        includePlans: "true",
        includeWorkouts: "true",
        countPerSection: (range !== null && range !== void 0 ? range : 4),
    }, { cacheKey: "previews" });
    return response;
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlzY292ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYXBpL2Rpc2NvdmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQVEsTUFBTSxTQUFTLENBQUM7QUFhcEMsTUFBTSxVQUFVLGlCQUFpQixDQUM3QixPQUFpQjs7SUFFakIsT0FBTyxPQUFBLE9BQU8sMENBQUUsV0FBVyxNQUFLLFNBQVMsQ0FBQztBQUM5QyxDQUFDO0FBRUQsTUFBTSxVQUFVLGNBQWMsQ0FDMUIsSUFBYzs7SUFFZCxPQUFPLE9BQUEsSUFBSSwwQ0FBRSxXQUFXLE1BQUssTUFBTSxDQUFDO0FBQ3hDLENBQUM7QUFFRCxNQUFNLFVBQVUsaUJBQWlCLENBQzdCLE9BQWlCOztJQUVqQixPQUFPLE9BQUEsT0FBTywwQ0FBRSxXQUFXLE1BQUssU0FBUyxDQUFDO0FBQzlDLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxXQUFXLEdBQUcsR0FBOEIsRUFBRTtJQUN2RCxNQUFNLFFBQVEsR0FBRyxNQUFNLEdBQUcsQ0FHdEIsd0JBQXdCLEVBQ3hCO1FBQ0ksZUFBZSxFQUFFLE1BQU07UUFDdkIsZUFBZSxFQUFFLENBQUM7S0FDckIsRUFDRCxFQUFFLFFBQVEsRUFBRSxnQkFBZ0IsRUFBRSxDQUNqQyxDQUFDO0lBQ0YsTUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLFFBQVEsQ0FBQztJQUNuQyxPQUFPLFFBQVEsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO1FBQ3hCLFFBQVEsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDOUI7SUFDRCxPQUFPLFFBQVEsQ0FBQztBQUNwQixDQUFDLENBQUEsQ0FBQztBQVFGLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxDQUFPLEtBQWMsRUFBc0IsRUFBRTtJQUNwRSxNQUFNLFFBQVEsR0FBRyxNQUFNLEdBQUcsQ0FDdEIsd0JBQXdCLEVBQ3hCO1FBQ0ksZUFBZSxFQUFFLE1BQU07UUFDdkIsWUFBWSxFQUFFLE1BQU07UUFDcEIsZUFBZSxFQUFFLE1BQU07UUFDdkIsZUFBZSxHQUFFLEtBQUssYUFBTCxLQUFLLGNBQUwsS0FBSyxHQUFJLENBQUMsQ0FBQTtLQUM5QixFQUNELEVBQUUsUUFBUSxFQUFFLFVBQVUsRUFBRSxDQUMzQixDQUFDO0lBQ0YsT0FBTyxRQUFRLENBQUM7QUFDcEIsQ0FBQyxDQUFBLENBQUMifQ==